module.exports = __webpack_public_path__ + "img/242.0d9450b5.jpg";